// copied from: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/3c89aee1836bb1efd278f39f1bb316d4f77c6c81/static/js/users-and-teams/operators/filterOutSearchResults.ts

import { searchResults } from './searchResults';
export const filterOutSearchResults = (options, input) => input ? options.map(group => Object.assign({}, group, {
  options: searchResults(group.options, input)
})) : options;